import { ReactElement, ReactNode, CSSProperties, memo } from 'react'
import PropTypes from 'prop-types'
import { animated } from 'react-spring'

import ScrollLink from '@/lib/scroll'

import { useHooks } from './methods'

import Container from './style'
const AnimatedContainer = animated(Container)

export interface Props {
  href: string
  hash?: string
  children: ReactNode | string
  isSelected?: boolean
  style?: CSSProperties
  className?: string
  id?: string
}

export interface State {
  isHovered: boolean
}

function NavigatorButton({
  id,
  children,
  className,
  style,
  href,
  hash,
  isSelected,
}: Props): ReactElement {
  const { containerSpring, underlineSpring, setHover, resetHover } = useHooks()

  return (
    <ScrollLink
      url={{
        pathname: href,
        hash: hash,
      }}
    >
      <AnimatedContainer
        id={id}
        className={`${className} ${isSelected ? 'selected' : 'not-selected'}`}
        style={{
          ...style,
          ...containerSpring,
        }}
        onMouseEnter={setHover}
        onMouseLeave={resetHover}
      >
        <figure>
          <animated.div
            className="anchor-underline"
            style={underlineSpring}
          ></animated.div>
        </figure>
        {children}
      </AnimatedContainer>
    </ScrollLink>
  )
}

NavigatorButton.propTypes = {
  style: PropTypes.object,
  className: PropTypes.string,
  id: PropTypes.string,
}

NavigatorButton.defaultProps = {
  className: '',
  isSelected: false,
}

export default memo(NavigatorButton)
